/**
 * PRIVATE LOCK BADGE
 *
 * Shown only in the OWNER's own views — public viewers never see private
 * items in the first place. Two variants:
 *   - `overlay` (default): small circular icon anchored top-right of an
 *     item tile. Tight, unobtrusive.
 *   - `chip`: pill with an icon + "Private" label. For detail pages and
 *     anywhere the icon-alone would be ambiguous.
 */

import React from 'react';
import { Lock } from 'lucide-react';

interface Props {
  variant?: 'overlay' | 'chip';
  className?: string;
}

const PrivateLockBadge: React.FC<Props> = ({ variant = 'overlay', className = '' }) => {
  if (variant === 'chip') {
    return (
      <span
        title="Only visible to you"
        className={`inline-flex items-center gap-1 rounded-full bg-slate-700/80 border border-slate-500 px-2 py-0.5 text-xs text-slate-100 font-body ${className}`}
      >
        <Lock className="w-3 h-3" />
        Private
      </span>
    );
  }
  return (
    <span
      title="Only visible to you"
      className={`absolute top-1 right-1 z-10 flex items-center justify-center rounded-full bg-slate-900/80 border border-slate-500 w-6 h-6 ${className}`}
    >
      <Lock className="w-3 h-3 text-slate-100" />
    </span>
  );
};

export default PrivateLockBadge;
